// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2JuTO","label":"LabeledBox_label__1HK9p"};